export const CLUSTER_MAX_ZOOM = 14;
